import { styled } from "styled-components";

export const CartTitle = styled.div`
  padding-top: 24px;
  font-size: 24px;
  font-weight: 600;
`;
